import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconExchange = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4058 7.35702C20.7685 7.71965 20.8154 8.2705 20.5316 8.63597L20.4602 8.71684L18.2845 10.8926L16.8703 9.47834L17.4022 8.94628H3V6.94628H17.3844L16.7434 6.30543L18.0488 5L20.4058 7.35702ZM3.18384 15.9456C2.90007 15.5801 2.94697 15.0293 3.3096 14.6667L5.66662 12.3096L6.97205 13.6151L6.33102 14.2559H20.4099V16.2559H6.31344L6.84513 16.788L5.43092 18.2022L3.25521 16.0265L3.18384 15.9456Z"
        />
      </svg>
    );
  }
);
